import { ChatConfig, ChatData, MessageType } from '../../common/components/Chat/Chat.types';
import { DesignTemplateData } from './DesignAI.types';

/**
 * SuggestionMessage Component
 */
export const sampleTopicList = [
  'Tips to work from home efficiently',
  'Impacts, causes, and solutions of climate change',
  'Fun facts about plants',
];

/**
 * DesignMessage Component
 */
export const GENERATING_MESSAGE = `
Ok, I am creating your infographic now...
Just so you know, I may occasionally generate incorrect information.
Also, I can't generate specialized widgets like timelines, charts, or maps.
After I create your infographic you can ask me to generate another but I'm not able to make adjustments to this one.
This won't take much longer. It takes time to generate each infographic because every design is unique.
Adding the finishing touches
`.trim();
const TYPE_SPEED = 60;
const DELAY_PER_LINE = 1000;
const LOADING_DOT_TYPE_SPEED = 1000;

/**
 * ChatContainer
 */
export const defaultChatData: ChatData[] = [
  {
    type: MessageType.BOT,
    messages: ['Give me a topic for your infographic or choose an example topic below.'],
    createdAt: Date.now(),
  },
  {
    type: MessageType.SUGGESTION,
    messages: sampleTopicList,
    createdAt: Date.now(),
  },
];

/**
 * Sample Data
 */
export const BASE_INFOGRAPH_TEMPLATE_ID_LIST: DesignTemplateData[] = [
  {
    e2DesignId: 'PmTmrDkEzhCVJOiaTV4LhmPn0P1H',
    e2DesignTitle: 'The Future of Cloud Computing',
    e1TemplateId: '5882396d-434e-4ea0-999f-356e204907cb',
  },
  {
    e2DesignId: 'dwInvUOYO2AeGPbrUSevzG1CB7cN',
    e2DesignTitle: '5 Cool Android Phone Apps',
    e1TemplateId: '288c6c38-b12a-4033-a4d2-09cbca45b238',
  },
  {
    e2DesignId: 'ZDqiqAWiEtIGpy6DYwnm2cCP9RVL',
    e2DesignTitle: 'Your Healthy Fitness Journey',
    e1TemplateId: 'ff0b8937-7733-4100-b549-0cf73a7ed4ca',
  },
  {
    e2DesignId: 'G514UBHW7fsDnxtZTEEd4IK2RE6y',
    e2DesignTitle: 'Diversity and Inclusion Terminology Infographic',
    e1TemplateId: 'dbc47165-dee4-478f-a0b9-313a54a533',
  },
  {
    e2DesignId: 'uxzsM4E3oP9rVVBQH8J5M1OboQcZ',
    e2DesignTitle: 'Internal Recruitment Methods Infographic',
    e1TemplateId: '0fbcf47e-1f8e-4786-81fd-4ecb54be280c',
  },
  {
    e2DesignId: 'U2lA7BK5XJGn0rKzb69XPVvTPiSO',
    e2DesignTitle: 'TYPES OF CHEMICAL REACTIONS',
    e1TemplateId: 'a9a003c4-0892-4282-89ad-7447f4345dea',
  },
  {
    e2DesignId: '06v2p74MazmO3yZsBGLNvSC4GEuS',
    e2DesignTitle: '4 Mind-Blowing  Science Facts',
    e1TemplateId: 'f7764a52-3dba-4e98-9e9b-b2c37680879b',
  },
  {
    e2DesignId: 'aC5RZNT0h7xhUawK7vcpEpqNdYsa',
    e2DesignTitle: 'Online Social Event Planning Infographic',
    e1TemplateId: '421fab76-b106-465b-8bfe-37a62f345b7b',
  },
  {
    e2DesignId: 'E9seikE5pLXcW0KlpqbR72SUSb9W',
    e2DesignTitle: 'EVERYTHING YOU NEED TO KNOW  ABOUT STOCKS',
    e1TemplateId: 'a87fc328-d954-49f3-9877-b81857aad8f4',
  },
  {
    e2DesignId: 'G5ao22ffzRNjoQNE5AH4NnK4j16I',
    e2DesignTitle: 'Employee Change Style Indicator Spectrum',
    e1TemplateId: '30770961-3e54-4c8f-826d-9db79f6a91c3',
  },
  {
    e2DesignId: 'MPeEtB6HkqKCtKoormYpHvp2xZFI',
    e2DesignTitle: 'Facebook Infographic Template',
    e1TemplateId: 'e3860998-a6ec-4bef-9a00-3e0abb3a15ad',
  },
  {
    e2DesignId: 'SJ81jprcIWtW98dIG8AFMlkohD1M',
    e2DesignTitle: 'Free Authoring Tools',
    e1TemplateId: '09feb17a-f6da-4c38-8b73-adc911cb3369',
  },
  {
    e2DesignId: 'GNiXzwRWIqfTLGhDSb9Orj8Mm3GZ',
    e2DesignTitle: 'How Can Coaches Assign Points to Goals and Tasks in Training Tasks',
    e1TemplateId: '8ea22839-76c3-44c7-a271-219bfaf24ba8',
  },
  {
    e2DesignId: 'u9tIbIlWFOUmFDYFgMvs1DGngnTm',
    e2DesignTitle: 'Vintage Project Management Plan Infographic',
    e1TemplateId: 'e967931a-986b-47e6-ac47-e2f06a3a1510',
  },
  {
    e2DesignId: 'Dl0tTTTTb4fPTIFa4Tzp7wnz2Sn8',
    e2DesignTitle: 'Computer Aided Design List Infographic',
    e1TemplateId: 'ec7e2c79-fac1-4538-88fc-f8d301c20031',
  },
  {
    e2DesignId: '5LfgvSID837T8IAA8LqccDtqWXr9',
    e2DesignTitle: '7 Unique Facts About Animals',
    e1TemplateId: 'c1f99977-1766-4d3b-824f-e2d584f54beb',
  },
  {
    e2DesignId: 'lRjkv9MKwOJwO29TNkQfSUa5lM0c',
    e2DesignTitle: 'Tree Infographic Template',
    e1TemplateId: '32e1f8b4-8da3-4b22-87ad-c49919066bb5',
  },
  {
    e2DesignId: 'pmGN2NqWENHd2FK1uKnRC13cUIM3',
    e2DesignTitle: 'A guide to sustainable eating: how to make eco-friendly food choices',
    e1TemplateId: '49e9461f-9948-410c-b0d3-881c8d466e8a',
  },
  {
    e2DesignId: '8Gymrv9GBwFBSZdRXZjltHCw7Dr9',
    e2DesignTitle: 'The Science of Flavor: Exploring the Chemistry Behind Our Favorite Tastes',
    e1TemplateId: '8d555ad1-398d-4da2-858c-7e8c8636071c',
  },
];

export const DESIGN_AI_CHAT_CONFIG: ChatConfig = {
  [MessageType.BOT_GENERATING]: {
    typeSpeed: TYPE_SPEED,
    delayPerLine: DELAY_PER_LINE,
    loadingDotTypeSpeed: LOADING_DOT_TYPE_SPEED,
  },
};
